import api from './client'
import type {
  PaymentStartResponse,
  PaymentCompleteRequest,
  MemberDuesInfo,
} from '../types'

export async function getDuesStatus(): Promise<MemberDuesInfo> {
  const { data } = await api.get<MemberDuesInfo>('/payments/dues/status')
  return data
}

export async function startDuesPayment(): Promise<PaymentStartResponse> {
  const { data } = await api.post<PaymentStartResponse>('/payments/dues/start')
  return data
}

// pending: the payment may already be collected and is still being confirmed (HTTP 202).
export async function completeDuesPayment(
  req: PaymentCompleteRequest,
): Promise<{ success?: boolean; pending?: boolean; message?: string }> {
  const { data } = await api.post('/payments/dues/complete', req)
  return data
}
